import { createValidation } from '../../../utils/validation';
export const createChangeCategoryValidation = (fields) => { const validation = createValidation(fields); return { schema: validation.schema, validateData: validation.validateData, validateChangeCategoryData: validation.validateData, validateField: validation.validateField }; };
export default createChangeCategoryValidation;
